import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Home from '../pages/Home';
import Documentation from '../pages/Documentation';
import DocumentationView from '../pages/DocumentationView';
import About from '../pages/About';
import Contact from '../pages/Contact';
import PageTransition from './PageTransition';
import { NavigationContext } from './NavigationContext';

const AnimatedRoutes = () => {
  const location = useLocation();
  const [isNavigating, setIsNavigating] = useState(false);
  
  useEffect(() => {
    // Marquer le début de la navigation
    setIsNavigating(true);
    
    // Définir la durée totale de la transition
    const navigationTimer = setTimeout(() => {
      setIsNavigating(false);
    }, 2200); // Durée totale des transitions (ajuster si nécessaire)
    
    return () => clearTimeout(navigationTimer);
  }, [location.pathname]);
  
  return (
    <NavigationContext.Provider value={{ isNavigating }}>
      <AnimatePresence mode="wait" initial={false}>
        <PageTransition key={location.pathname}>
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/documentation/:lang" element={<DocumentationView />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </PageTransition>
      </AnimatePresence>
    </NavigationContext.Provider>
  );
};

export default AnimatedRoutes;